import React, { useState,useEffect } from "react";
import { Link,useLocation,useNavigate  } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars,faListCheck,faCalendar,faScrewdriverWrench,faHistory,faChalkboardTeacher,faShirt,faClipboardList,faCubes,faChartPie,faUsers} from "@fortawesome/free-solid-svg-icons";
import "./Sidebar.css"; // Stile CSS
import { removeToken,setSidebar,getSidebar,getRuolo,setLingua,getLingua,setPagina,getPagina,getInizioPeriodo,setInizioPeriodo,setFinePeriodo,getFinePeriodo } from "./auth";
import { decriptaRuolo } from "./funzioni/funzioni_utili";
import { DateTime } from 'luxon';
/* global $ */
const Sidebar = () => {
const paginaAttuale=parseInt(getPagina())||0
const locationn = useLocation();
const isLoginPage = locationn.pathname === "/login";
let pages=null
let inizioModIn=null
let fineModIn=null
let inizioModFin=null
let fineModFin=null
if (paginaAttuale===0){
     pages = [
      { path: "/agenda", label: <><FontAwesomeIcon icon={faCalendar} />Agenda</> },
      { path: "/plan", label: <><FontAwesomeIcon icon={faListCheck} />Plan giornata</> },
      { path: "/storico", label: <><FontAwesomeIcon icon={faHistory} />Storico</> },
      { path: "/instructors", label: <><FontAwesomeIcon icon={faChalkboardTeacher} />Istruttori</> },
      { path: "/analysis", label: <><FontAwesomeIcon icon={faChartPie} />Bilancio</> },
      { path: "/accessories", label: <><FontAwesomeIcon icon={faShirt} />Magliette</> },
      { path: "/users", label: <><FontAwesomeIcon icon={faUsers} />Utenti</> },
      { path: "/equipment", label: <><FontAwesomeIcon icon={faCubes} />Inventario</> },
    ]
}
if (paginaAttuale===1){
     pages=[
      { path: "/bookingsvilla", label: <><FontAwesomeIcon icon={faCalendar} />Prenotazioni villa</> },
      { path: "/storicovilla", label: <><FontAwesomeIcon icon={faHistory} />Storico villa</> },
      { path: "/analysisvilla", label: <><FontAwesomeIcon icon={faChartPie} />Analisi villa</> },
    ]
}
let valorSid=getSidebar()
  if (typeof getSidebar()==="string"){
    valorSid= getSidebar() === "true"
  }
  const [isOpen,setIsOpen]=useState(valorSid)
const ruolo=decriptaRuolo(getRuolo(),"scuolaKitesurfKenya")
const dataSource=[{"id":1,"name":"Italiano"},{"id":2,"name":"English"},{"id":3,"name":"Deutsch"},{"id":4,"name":"Español"}]
let valoreLingua=1
if (getLingua()) valoreLingua=parseInt(getLingua())
useEffect(() => {
if (isOpen)
{$("#sidebarScrollWrapper").dxScrollView({
      useNative: true,
      direction: "vertical",
      showScrollbar: "onScroll"
    });}
    $("#selectboxlingua").dxSelectBox({
      dataSource: dataSource,
      displayExpr: "name",
      valueExpr: "id",
      value: valoreLingua,
      onValueChanged: function (e) {
        setLingua(e.value);
        window.location.reload()
      },
    });

  if (isOpen && (ruolo === 0 || ruolo === 1)) {
  const tabsIconAndText=[
      { id: 0, text: 'Scuola'},
      { id: 1, text: 'Casa'},
    ];
    $("#tabsAmbiente").dxTabs({
      width: '90%',
      rtlEnabled: false,
      showNavButtons: false,
      dataSource: tabsIconAndText,
      orientation: "horizontal",
      onSelectionChanged: function(e){
        let newIndex = e.component.option("selectedIndex");

        const pagina = parseInt(getPagina())
        if (newIndex===-1) newIndex=parseInt(getPagina())
        if (newIndex!==pagina){
            if (newIndex===0){
                window.location.href = "/agenda";
                // window.location.reload()
                setPagina(newIndex)
            }
            else {
                window.location.href = "/bookingsvilla";
                 // window.location.reload()
                 setPagina(newIndex)
            }
        }
      }

    });
   if ($("#tabsAmbiente").dxTabs("instance").option("selectedIndex")<0)
   $("#tabsAmbiente").dxTabs("instance").option("selectedIndex",parseInt(getPagina()))
  }
}, [isOpen, ruolo]);
function toggleVisibility() {
  const element = document.querySelector('.sidebar');
  element.style.transition = "none";

  // Scompare
  element.style.opacity = "0";

  // Dopo 300ms riappare
  setTimeout(() => {
    element.style.transition = "opacity 0.3s ease";
  element.style.opacity = "1";
  }, 150);
}
  const location = useLocation();
  const navigate = useNavigate()
      if (isLoginPage) return null
  const handleLogout = () => {
        removeToken();
        setSidebar(true);
        window.location.href = "/login";
    };
  if (ruolo===0||ruolo===1){

   }
else {
    if (ruolo===2 || ruolo===5){
    pages=[{ path: "/agendainstructor", label: <><FontAwesomeIcon icon={faCalendar} />{{
    1: "Agenda",
    2: "Schedule",
    3: "Zeitplan",
    4: "Agenda"
  }[parseInt(getLingua())]}</> },
  { path: "/instructorstoric", label: <><FontAwesomeIcon icon={faHistory} />{{
    1: "Lezioni e pagamenti",
    2: "Lessons and Payments",
    3: "Unterricht und Zahlungen",
    4: "Clases y pagos"
  }[parseInt(getLingua())]}</> },
  { path: "/analisisyntructor", label: <><FontAwesomeIcon icon={faChartPie} />{{1: "Bilancio",2: "Economic Analysis",3: "Wirtschaftsanalyse", 4: "Análisis económico"}[parseInt(getLingua())]}</> },
  //{ path: "/user", label: <><FontAwesomeIcon icon={faUsers} />{{ 1: "Profilo",2: "Profile", 3: "Profil",4: "Perfil"}[parseInt(getLingua())]}</> },
  ]
}
else
    {
        pages = [
  {
    path: "/bookingsvilla",
    label: (
      <>
        <FontAwesomeIcon icon={faCalendar} />
        {{
          1: "Prenotazioni villa",
          2: "Villa bookings",
          3: "Villa-Buchungen",
          4: "Reservas villa"
        }[parseInt(getLingua())]}
      </>
    )
  },
  {
    path: "/storicovilla",
    label: (
      <>
        <FontAwesomeIcon icon={faHistory} />
        {{
          1: "Storico villa",
          2: "Villa history",
          3: "Villa-Verlauf",
          4: "Historial villa"
        }[parseInt(getLingua())]}
      </>
    )
  },

];

    }}
  return (

    <div className={`sidebar ${isOpen ? "open" : ""}`}>
    <div id="sidebarScrollWrapper" style={{width:"100%"}}>
    <div id="sidebarScrollContent" >
    {isOpen && (<img src="/logo11.png" alt="Logo" width="100px" height="auto"/>)}
      <div className="sidebar-header">
      <button className={`menu-button ${isOpen ? "open" : ""}`} onClick={() => {
      setSidebar(!isOpen);
      const mainContent = document.getElementById("main-content")
      const divs = mainContent.querySelectorAll("div[id*='grid'], div[id*='scheduler'], div[id*='chart']");
      //divs.forEach(div => {
       //$(`#${div.id}`).addClass("grid-container-hidden")
       //;})
      toggleVisibility()
      setTimeout(()=>{
      divs.forEach(div => {
      if (div.id.includes("grid"))
      $(`#${div.id}`).dxDataGrid("instance").repaint();
      else if (div.id.includes("scheduler"))
      $(`#${div.id}`).dxScheduler("instance").repaint()
      else if (div.id.includes("chart") && !(div.id.includes("Pie"))){

      $(`#${div.id}`).dxChart("instance").render()}
      else if (div.id.includes("Pie")){
      $(`#${div.id}`).dxPieChart("instance").render()}

      })
      //$(`#${div.id}`).removeClass("grid-container-hidden")})
      },250)
      if (isOpen) {
      mainContent.classList.remove("sidebar-open")
      mainContent.classList.add("sidebar-closed")
      }
      else {
      mainContent.classList.remove("sidebar-closed")
      mainContent.classList.add("sidebar-open")
      }
      setIsOpen(!isOpen)
      }
      }>
        <FontAwesomeIcon icon={faBars} />
      </button>
      {(!isOpen) && (<img style={{position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)"}} src="/logo.png" alt="Logo" width="50" height="50"/>)}
      <button className={`logout-button ${isOpen ? "visible" : "hidden"}`} onClick={handleLogout}>
          Logout
        </button>

      </div>
      { (isOpen) && (ruolo===1 || ruolo===0) && (<div id="tabsAmbiente" style={{ margin:"10px",background: "white", zIndex: 9999, position: "relative",}}></div>)}
      {isOpen &&
      (

      <nav>
            <div className="dropdown-content">
              {pages.map((page, index) => (
            <Link
              key={page.path}
              to={page.path}
              className={location.pathname === page.path ? "active" : ""}
              style={{ animationDelay: `${index * (0.7 / pages.length)}s` }} // 🔹 Delay automatico
            >
              {page.label}
            </Link>
          ))}
        </div>
      </nav>)}
    { (isOpen)  && (<div id="selectboxlingua" style={{ margin:"10px",background: "white", zIndex: 9999, position: "relative" }}></div>)}
    </div>
  </div>
    </div>
  );
};

export default Sidebar;